import axios from 'axios'
import i18n from '@/i18n'
import store from '@/store/store'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

api.interceptors.request.use(
  config => {

    config.headers.language = i18n.locale
    const token = store.getters['user/token']
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }

    // Organization context: per-request override (e.g. when fetching org by id before store is set) or from store
    const currentOrgId = config.organizationId !== undefined && config.organizationId !== null
      ? config.organizationId
      : store.getters['dashboard/activeOrganizationId']
    if (currentOrgId !== null && currentOrgId !== undefined) {
      config.headers['X-Organization-Id'] = currentOrgId
    }

    // Replace {orgId} placeholder in URLs
    if (config.url.includes('{orgId}')) {
      if (currentOrgId) {
        config.url = config.url.replace(/{orgId}/g, String(currentOrgId))
      } else {
        console.error('Organization ID not found in context for URL:', config.url)
      }
    }

    var url = config.url.toLowerCase()
    if (url.startsWith('/')) {
      var baseUrl = config.baseURL
      baseUrl = baseUrl.slice(0, -8)
      config.baseURL = baseUrl
    }

    return config
  },

  error => Promise.reject(error)
)

api.interceptors.response.use(
  (response) => {
    return response
  },
  
  (error) => {
    const resp = error.response
    if (resp){
      if (resp.status === 401) {
        let token = store.getters['user/token']
        if (error.config && !error.config.__isRetryRequest && token){
          store.dispatch('user/logout')
          location.reload();
        } else {
          //throw error
        }
      }
    }


    return Promise.reject(error)
  })

export default api
